const d = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, C = (e, n, r) => n + 2 < r && d(e.charCodeAt(n + 1)) && d(e.charCodeAt(n + 2));
function p(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:"))
    return 0;
  const n = e.indexOf(",");
  if (n < 0)
    return 0;
  const r = e.slice(5, n), t = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let o = t.length;
    const a = t.length;
    for (let s = 0; s < a; s++)
      if (t.charCodeAt(s) === 37 && s + 2 < a) {
        const x = t.charCodeAt(s + 1), A = t.charCodeAt(s + 2);
        d(x) && d(A) && (o -= 2, s += 2);
      }
    let i = 0, c = a - 1;
    const l = (s) => s >= 2 && t.charCodeAt(s - 2) === 37 && // '%'
    t.charCodeAt(s - 1) === 51 && // '3'
    (t.charCodeAt(s) === 68 || t.charCodeAt(s) === 100);
    c >= 0 && (t.charCodeAt(c) === 61 ? (i++, c--) : l(c) && (i++, c -= 3)), i === 1 && c >= 0 && (t.charCodeAt(c) === 61 || l(c)) && i++;
    const h = Math.floor(o / 4) * 3 - (i || 0);
    return h > 0 ? h : 0;
  }
  let f = 0;
  for (let o = 0, a = t.length; o < a; o++) {
    const i = t.charCodeAt(o);
    if (i === 37 && C(t, o, a))
      f += 1, o += 2;
    else if (i < 128)
      f += 1;
    else if (i < 2048)
      f += 2;
    else if (i >= 55296 && i <= 56319 && o + 1 < a) {
      const c = t.charCodeAt(o + 1);
      c >= 56320 && c <= 57343 ? (f += 4, o++) : f += 3;
    } else
      f += 3;
  }
  return f;
}
export {
  p as default
};
